<template>
  <div class="page-content" style="padding: 0px !important;">
    <can I="manage" a="mine">
      <Performance></Performance>
    </can>
    <can I="manage" a="installation">
      <div class="container-fluid" style="padding: 0px !important;">
        <div class="google-map" id="geoDistroMap"></div>

        <div role="tablist" class="legend_accordion">
          <b-card no-body class="mb-1 legend_box">
            <b-card-header header-tag="header" class="p-1" role="tab" style="padding: 0px;">
              <b-button
                block
                href="#"
                v-b-toggle.accordion-1
                variant="info"
              >Geographical Distribution</b-button>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <h6 class="box-card-subtitle" style="padding: 5px;">Device Status</h6>
                <div class="legend-keys text-center" style="padding: 5px 5px;">
                  <div class="keys">
                    <span class="text-center">
                      <img class="icon" src="../../../assets/img/checked.png" alt="checked-icon" />
                    </span>
                    Device Ok
                  </div>
                  <div class="keys">
                    <span>
                      <img class="icon" src="../../../assets/img/warning.png" alt="warning-icon" />
                    </span>
                    Device Warning
                  </div>
                  <div class="keys">
                    <span>
                      <img class="icon" src="../../../assets/img/error.png" alt="error-icon" />
                    </span>
                    Device Error
                  </div>
                </div>
                <b-list-group horizontal="md">
                  <b-list-group-item>
                    All Devices
                    <strong style="float: right;">{{markers.length}}</strong>
                  </b-list-group-item>
                  <b-list-group-item>
                    Devices with warning
                    <strong style="float: right;">{{devicesWithWarning}}</strong>
                  </b-list-group-item>
                  <b-list-group-item>
                    Devices with fault
                    <strong style="float: right;">{{devicesWithFault}}</strong>
                  </b-list-group-item>
                </b-list-group>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </can>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>

<script>

    /**
     * Returns the Popup class.
     *
     * Unfortunately, the Popup class can only be defined after
     * google.maps.OverlayView is defined, when the Maps API is loaded.
     * This function should be called by initMap.
     */
   function createPopupClass() {
      /**
       * A customized popup on the map.
       * @param {!google.maps.LatLng} position
       * @param {!Element} content The bubble div.
       * @constructor
       * @extends {google.maps.OverlayView}
       */
      function Popup(position, content) {
        this.position = position;

        content.classList.add("popup-bubble");

        // This zero-height div is positioned at the bottom of the bubble.
        var bubbleAnchor = document.createElement("div");
        bubbleAnchor.classList.add("popup-bubble-anchor");
        bubbleAnchor.appendChild(content);

        // This zero-height div is positioned at the bottom of the tip.
        this.containerDiv = document.createElement("div");
        this.containerDiv.classList.add("popup-container");
        this.containerDiv.appendChild(bubbleAnchor);

        // Optionally stop clicks, etc., from bubbling up to the map.
        google.maps.OverlayView.preventMapHitsAndGesturesFrom(
          this.containerDiv
        );
      }
      // ES5 magic to extend google.maps.OverlayView.
      Popup.prototype = Object.create(google.maps.OverlayView.prototype);

      /** Called when the popup is added to the map. */
      Popup.prototype.onAdd = function() {
        this.getPanes().floatPane.appendChild(this.containerDiv);
      };

      /** Called when the popup is removed from the map. */
      Popup.prototype.onRemove = function() {
        if (this.containerDiv.parentElement) {
          this.containerDiv.parentElement.removeChild(this.containerDiv);
        }
      };

      /** Called each frame when the popup needs to draw itself. */
      Popup.prototype.draw = function() {
        var divPosition = this.getProjection().fromLatLngToDivPixel(
          this.position
        );

        // Hide the popup when it is far out of view.
        var display =
          Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
            ? "block"
            : "none";

        if (display === "block") {
          this.containerDiv.style.left = divPosition.x + "px";
          this.containerDiv.style.top = divPosition.y + "px";
        }
        if (this.containerDiv.style.display !== display) {
          this.containerDiv.style.display = display;
        }
      };

      return Popup;
    }
/* eslint-disable */
var Weather = require("weather.js");
Weather.setApiKey("38e055e82a20b42d48ed5131d67eada7");
import Vue from "vue";
var ib = null;
const icon =
" data:image/png;base64,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";
  // "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAtCAYAAABS6WCiAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4wQKCh4fkucy1AAACq5JREFUWMNVmM2PZNdZxn/ve879qOqq7p6Z7ml7xo6HyTh2RGxkhLKwSBasyAbxH4CExJI/gD+AHdlklTUSYsWCBZsgsQCJCESEE8d2bMdjtz2eD09PT3d1V92Pc96XxbldAyUd3epbVec5z/v1PLfFf/xHjii4g2ewDDaCJbBETs4qRR6Mu3ySjngv3+GXdpdf8jrHmznN2SPenj3ihzuf8sPmI96KxxyFc6JkQMAFcDAryzPiP/mRM93PGc5T5OEw57PuGr/pD3l/uMWn4yFf2gEnvmSjLTnUSAjI8ByePsb6joCxrI3X5he8M3/Eu+19/qD5grvhCbtygdhYAMyQj//2z/3Xm0M+WB/wweaAjzc3+Crtc2o79NLgIYIGCIoEBdXyXgWhwy86yFYik3ps6GAcCDZwI3S83p7y/fmXvDv7jHeq+9zWE+TP/uon/g9P36KXOYQIoUJCKJurggqiAiLbv8tyxDb4ZQfmIAFEp5A6DAM+9vjQwdDR0PFyPONPd39F/Prr39KH30V25tNmAUFAKC/LiBlYD7mDPOB7L0NVAyAOuOPi4Lx4iaICzPbwes6YRz4f9/lFd0HcnNyH692U1ISMl5A7JG2QtIa0RnwAMuQBXPD5dbyqEXfcKYfcnhLwgKwfE977KX7tDTj6fXJcQmjJoSWmOz+CdIicfYZcPikJJ5VDYAhe9lOdGDTItL8AiBS2TCnwq6vhZ8e0VeD7736HdZjz82PBRInWXodLJeQ1pMuyuU87+nZnxP0FGZEthkWkrz666hBUaXfnmDofr16hnc+ATCYQ1UsiNFa4hm3RWM5TUdUQKog1UrVQLyE2iAgq4FKKCvFyRgdwvF6Qlm/gEnmwWuArcDdMItFsQNywMMfnL0MzR6oW12qq5hoJFWiEEJAYkBhBCxYi+ES7HH8Cr3ew7/4l7pkgFW6JZIK5EsPn/wK7R9jeq7BUCGEbQXDErbAPimphhziighq4Xk0duYLDp3ceIngEyzhXM0iJEltEAjiIOLgjPiIPfo48v48cvY28/Hslfyro1LcqUg4WBLJumbqDu+NazmKUdiqgjqHo5at/jLR7qBnioIBYj3z4d8h//Rj95teoCkEhTNdYiBPViQpRjJh6oiUiRsAJOKo+RQZUHJ2g40Z2S5e5IZTBLxKQl95BFrfRw++Ug4gQhP/DtGzoKoh1+NP3AS1MCOT2EOISLk9xCZgLQlVaprRhOQVuiCgSWuTtvyg5DIpqEaIQSnhDUDSAmpRJJA7e4+5YTlg2JLZkF+T5h5AdMcPnt7H5gmhcndqRqfFEBdGGUj9ewFUJqmgIhFDCLDEgMuIKxIiZYYCRyNtcgUuRNLWMuxCDOEU8DkWhPCDmE/uMBiHEQBiNIEYIEHZfIsQa1QAhQWzwgzexnLGcyTkhOgMLsPvKNPgHJM5LTkVKgcyqFdiGPI6wWSF9X/JYN2hTEVSIJAKZsLhGlKpEJwhUFRZvkA1yzkV1HHzM+LV76JjwcUTHEfcLogJRhLqNuMzQ1GBVRM5PkHEoTBVCPSeIEcdzgnoJu0N49gFy+gWOkOKS8cZboA2Y45oxM1QNU0fEMZwYFaIa+eQbGC/AS7mLXw2AnjCOBBsJMaChKjouTvCMPvkP5Kt/L79rrhOuvYocHNH3cHE61Yob4iXbDsSgQgyg1QKJc4hX4y8iGkr1xoCGgARFo6BVW1hS2kZUkFDjMVK3wEIwNWYupAwxCcMg+MqxwYiqQhWEsDws81UVVy0uQAQNV22jaFAkTvcQytdKZUsIEANC6YIqCcmdoTdyNtwNCWDZiXUUahdCkKIU6pg4iJX2QREMnXpZPaAuW01VDYTYEJsWbWYMLmgHs6jYpdIPQlpnxmEkDQnTCXSGgG4lu4AqWPErqOs0tXwari909s7bP+DVd+6we/IcZ86/tbtsOkeBRRsIkyM5G4TBHXcnzurATAQDkjsZRRHcJz2X4iBwxa/8kPvkK+DmzX2+1/wPp9/6Aes0Q48jjBRBCLCcB6LWiJf+zRliWyu1Q7Ki+IKTEdyLRBmCSHFBZVROKnIlZ/mcZAOXDmc0GFaiIqXQgkAzjzTaEEhsziFWQanCpJ82aRNGnsyWOrg5qOBeJhXbMBvvP73FJ/InZFPMM0OWLahSGFcqzBcVs2rOqh2JUYUq8EJ8JxCb2JafglsRA3fH3MuoNOd8ENReSJ9MSqRSSrBIINRB2Wkbbu7sEWMQKmUbSjPHpqJxF8xLgaGCCQQRdDJg5oa6lcLyK88mW8OmKkQVYnBiUNoI81lTQKOWWZEdzIQshfeVr7Xpvpsj2dGgVB6JbohZ+d7kB6/cahF7IQYlRqcOTh2hrrkaDo65kMTJk+FSCgO3wj5RpovhiBihEiqgyU6L0SAghgIhZ4IoMVZUw3Nqy9TBqEJDHfcLaFTIYkQpmxf5M1ISxuwkhxEhT8YKMQZTOjc2/UhtA7P+IYs6s1MrdSPE+S5x9yZVekalQh0jbaioKiXGULxOslNk05Mue7qLjs1g9DkWeiBLRQ4Npg0eG6yeQwy4JcYh0fUdFydfcR6cnXnN/qLlmjZUSycEoakqmrqiriuaSoluzjAmVicnnD1/zsVmoB8TY4JkQjYruXYpFS0V/tI7uFZ4zrgZJMOHTGcjqz5zunaejh0H9Lw03+FosWA2b6nnNW2lxOMnFzy7GLl49Ixhs2Z0yCZkdyw72cvagrrhORXAnMCKXLFzhIeKFGb0seEi1Zw8HPi6jRxdJF69PnLnpnBrH+Jvvz5jzEK2GV7VZfOcyWnAJGFeqtrNMHHcDM9FnEkTUxF8cXvqmml+u5PGxHownq2M40fOp18GvnVQEy82HUiE+jomRUuMqT+zY5axPGJ5wPOAp7HYZpsArfyfwsUmOz3Jj7+YXL1l+jFxtk588SQR0zDgmiE4rqGImEbcA65KDjUWZ5jKZKEBrQpjLwqCpRePFS7lqZzpczPwBHkkjWty7omBkSElcnbQiEkgY9vHeZ8ekNwEE8M1TCDlKUwsQU7TQ1RRHzyBZSwNeOpQz4gbuzP43u8cIn//z//pv/jomH/81//Gmx2CRdr9W5wPkYsh0FlNJpaBL8VVuARcAuIZ+nMYBxwrZswzgtMEONyNvHF7h7de2+NnP/snlpzz07/5a+LN6jlv7p3xcrjPs9WAPz7m3t279KacdcJpX7PyPTbxBl19SGquk6sFhKZo6zhC6lEfaFizlBU3wnOO2o47uy139w55ZX7Er+Jjnl52PH78gPjhR7/h4cOHDN2a86cnNOtL7n/6ESEGLGek72nHkZidlppU7ZPmtxj3vk23/yZ68YRr4zF7/g0LzmllIIiRz4XPvlGOP6lYLBY8fXJCX7V8eXxM7LoOd+fNm/schAw3d8k5MwwDXdeRzSFlzAZsPEc2pzSrz5mdv8ftvT9kdfk1++MzlnUkVjVVVVFVLXVd07Yt8/mc5XLJt++9zmxnh73lgnhwcEDTNMzalqObN+m6js1mw3q93q7NZsNms2EYBsZxZBxHzJ2Fr2jvvIY8bzmohZ2dne1aLBYsl8v/txaLBbPZjHjv3j02mw2Xl2vW68stwBVY13X0fb8F7Pue1WrFxWrFg3XHbBnxquXN797lxvXrW3az2Wx7vVpN09I0Nf8L4z4Z/eH0Z84AAAAldEVYdGRhdGU6Y3JlYXRlADIwMTktMDQtMTBUMDk6MzA6MzErMDE6MDA079x1AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE5LTA0LTEwVDA5OjMwOjMxKzAxOjAwRbJkyQAAABp0RVh0ZXhpZjpCaXRzUGVyU2FtcGxlADgsIDgsIDgS7T4nAAAAIXRFWHRleGlmOkRhdGVUaW1lADIwMTk6MDQ6MTAgMDk6Mjk6NTWNkBvnAAAAFXRFWHRleGlmOkltYWdlTGVuZ3RoADExMjXHUk69AAAAE3RFWHRleGlmOkltYWdlV2lkdGgANzM18S/idgAAABl0RVh0ZXhpZjpTb2Z0d2FyZQBHSU1QIDIuMTAuOEmMRE0AAAAASUVORK5CYII=";
import { Card } from "element-ui";
import Simplert from "vue2-simplert";
import powerStat from "./powerStat";
import darkStyle from "./darkStyle.json";
import { timeAgoUtil } from "../../../main";
import moment from "moment";
import Battery from "../kitchen/grey-battery";
import { mapGetters, mapActions } from "vuex";
import { HTTP } from "../../../store/actions";
import axios from "axios";
// import RichMarker from 'js-rich-marker'

import Performance from "@/components/pages/submodules/performance";
let items = [];
Vue.use(Card);
export default {
  name: "dashboard",
  searchdata: "",
  components: {
    Performance,
    // Widget,
    powerStat,
    // Modal,
    // VuesticSimpleSelect,
    Simplert,
    Battery
  },
  computed: {
    ...mapGetters([
      "DeviceList",
      "getUserByDevice",
      "getUserSession",
      "getTheme",
      "getDeviceWarning"
    ])
  },
  data() {
    return {
      APP_ID: "18bec784",
      APP_KEY: "de70b01f7ec68244432eae21b3696402",
      markerFrequency: {},
      details: "devicePerformance",
      map: null,
      devicesWithWarning: 0,
      devicesWithFault: 0,
      markers: [],
      bounds: [],
      myDevices: [],
      fetchData: [],
      retData: {},
      markerCluster: {},
      mcOptions: {
        styles: [
          {
            height: 53,
            url:
              "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclusterer/images/m1.png",
            width: 53
          },
          {
            height: 56,
            url:
              "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclusterer/images/m2.png",
            width: 56
          },
          {
            height: 66,
            url:
              "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclusterer/images/m3.png",
            width: 66
          },
          {
            height: 78,
            url:
              "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclusterer/images/m4.png",
            width: 78
          },
          {
            height: 90,
            url:
              "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclusterer/images/m5.png",
            width: 90
          }
        ]
      },
      formDevice: {
        DeviceID: null,
        device_type: {
          name: "Arnergy 5000",
          description:
            "Bundled with : 3 LED bulbs, FM Radio and 1 x 20Wp High Efficiency Solar Panel.",
          status: 0,
          TimeStamp: new Date(),
          updatedAt: new Date()
        },
        location: {
          address: null,
          latitude: null,
          longitude: null
        },
        customer: {
          name: null,
          phone: null
        },
        subscription_type: {
          name: "Monthly Subscription",
          description: "User Pays Monthly",
          status: 0,
          TimeStamp: new Date(),
          updatedAt: new Date()
        },
        TimeStamp: new Date(),
        updatedAt: new Date(),
        outright_cost: 96796,
        initial_cost: 98533,
        installment_cost: 626882
      },
      deviceOptions: [
        "Arnergy 300",
        "Arnergy 1000",
        "Arnergy 2000",
        "Arnergy 5000"
      ],
      simpleSelectModel: "",
      timeRightNow: "",
      items: items,
      fields_: [
        {
          key: "id",
          label: "ID",
          sortable: "true",
          field: "id",
          filterable: true
        },
        {
          key: "status",
          label: "STATUS",
          sortable: "true",
          field: "status",
          filterable: true
        },
        {
          key: "owner",
          label: "OWN BY",
          sortable: "true",
          field: "owner",
          filterable: true
        },
        {
          key: "deviceId",
          label: "DEVICE ID",
          sortable: "true",
          field: "deviceId",
          filterable: true
        },
        {
          key: "pvpower",
          label: "PV POWER",
          sortable: "true",
          field: "pvpower",
          filterable: true
        },
        {
          key: "devicestatus",
          label: "DEVICE STATUS",
          sortable: "true",
          field: "devicestatus",
          filterable: true
        },
        {
          key: "expiry",
          label: "EXPIRY DATE",
          sortable: "true",
          field: "expiry",
          filterable: true
        },
        {
          key: "load",
          label: "LORD %",
          sortable: "true",
          field: "load",
          filterable: true
        },
        {
          key: "lastseen",
          label: "LAST SEEN",
          sortable: "true",
          field: "lastseen",
          filterable: true
        }
      ],
      currentPage: 1,
      // details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      flags: {
        faults: {
          InverterFault: "Inverter Fault",
          BusOver: "Bus Overload",
          BusUnder: "Bus Underload",
          BusSoftFail: "Bus Failed",
          InverterVoltageTooLow: "Inverter Voltage Too Low",
          InverterVoltageTooHigh: "Inverter Voltage Too High",
          InverterOverCurrent: "Inverter Overcurrent",
          InverterSoftFail: "Inverter failed (soft)",
          SelfTestFail: "Self test failed",
          OPDCVoltageOpen: "",
          BatteryOpen: "Battery Open",
          CurrentSensorFail: "Current Sensor failed"
        },
        warnings: {
          // LineFail: "Line Failed",
          OPVShort: "Pv Output Short Circuit",
          BatteryUnderShutdown: "Battery Under Shortdown",
          EepromFault: "EEPROM Fault",
          BatteryLowAlarm: "Battery Low",
          PVLoss: "No supply from PV",
          BatteryDerating: "Battery Derating"
        }
      }
    };
  },
  watch: {
    getTheme: function(newTheme, oldTheme) {
      if (this.map) {
        this.map.setOptions({
          styles:
            this.getTheme["theme-name"] == "dark-solarbase" ? darkStyle : {}
        });
      }
    }
  },
  methods: {
    ...mapActions(["fillDeviceList", "refreshList"]),
    onClose() {},
    errorCalc(Payload) {
      var excluded = [
          "id",
          "deviceID",
          "TimeStamp",
          "TimeStamp",
          "updatedAt",
          "lineFail"
        ],
        tempresult = "";
      var totalErr = 0;
      for (var property in Payload) {
        if (
          Payload.hasOwnProperty(property) &&
          excluded.indexOf(property) < 0
        ) {
          // do stuff
          if (Payload[property] > 0) {
            if (this.flags.warnings[property]) {
              tempresult = "warning";
            } else if (this.flags.faults[property]) {
              tempresult = "error";
            }
          }
        }
      }
      return tempresult;
    },
    alarms(inverterId) {
      var excluded = [
        "id",
        "deviceID",
        "TimeStamp",
        "TimeStamp",
        "updatedAt",
        "lineFail"
      ];
      let response = {
        inverter: {
          warning: [],
          faults: []
        },
        pv: {
          warning: [],
          faults: []
        },
        battery: {
          warning: [],
          faults: []
        }
      };
      let Payload = this.getDeviceWarning(inverterId);
      for (var property in Payload) {
        if (
          Payload.hasOwnProperty(property) &&
          excluded.indexOf(property) < 0
        ) {
          // do stuff
          if (Payload[property] > 0) {
            if (this.flags.warnings[property]) {
              if (
                this.flags.warnings[property].toLowerCase().indexOf("battery") >
                -1
              ) {
                response.battery.warning = [
                  ...response.battery.warning,
                  this.flags.warnings[property]
                ];
              } else if (
                this.flags.warnings[property].toLowerCase().indexOf("pv") > -1
              ) {
                response.pv.warning = [
                  ...response.pv.warning,
                  this.flags.warnings[property]
                ];
              } else {
                response.inverter.warning = [
                  ...response.inverter.warning,
                  this.flags.warnings[property]
                ];
              }
            } else if (this.flags.faults[property]) {
              if (
                this.flags.faults[property].toLowerCase().indexOf("battery") >
                -1
              ) {
                response.battery.faults = [
                  ...response.battery.faults,
                  this.flags.faults[property]
                ];
              } else if (
                this.flags.faults[property].toLowerCase().indexOf("pv") > -1
              ) {
                response.pv.faults = [
                  ...response.pv.faults,
                  this.flags.faults[property]
                ];
              } else {
                response.inverter.faults = [
                  ...response.inverter.faults,
                  this.flags.faults[property]
                ];
              }
              // return "error";
            }
          }
        }
      }
      // console.log(response);
      return response;
      // this.errorCalc(this.getDeviceWarning(inverterId))
    },
    getFetchData(inverterId) {
      try {
        return (
          this.fetchData.filter(x => x.solarKitIds == inverterId)[0] || {
            name: "Arnergy Solar",
            userId: "5"
          }
        );
      } catch (error) {
        return {
          name: "Arnergy Solar",
          userId: "5"
        };
      }
      //.then(res=> {return res[0].name}).catch((err)=> {return''})
      // return null || this.fetchData.filter(x => x.solarKitIds == inverterId)[0].name
    },
    filterIt(arr, searchKey) {
      if (searchKey.length < 3) return arr;
      else
        return arr.filter(obj =>
          Object.keys(obj).some(key => obj[key].includes(searchKey))
        );
    },
    getPopUp(deviceData, payload = null) {
      // console.log(deviceData);
      // console.log(payload);
      var { ACOutputApparentPower, EnergyData } = payload;
      var {
        InverterId,
        TimeStamp,
        OutputLoadPercent,
        id,
        panelpower,
        BatteryCapacity,
        deviceType,
        ownerName,
        ownerId,
        batteryMode,
        expiry,
        lastseen,
        location,
        generatedToday,
        peakToday
      } = deviceData;
      let faultsNwarning = this.alarms(InverterId, "inverter");
      // console.log(location.position.lat,location.position.lng);
      // let url_ = `https://api.weatherunlocked.com/api/current/${location.position.lat},${location.position.lng}?app_id=${this.APP_ID}&app_key=${this.APP_KEY}`;
      let url_ = `https://arnergy.com/weather-api/?loc=${location.position.lat},${location.position.lng}`;
      // Weather.getCurrent(location.position.lat,location.position.lng, function (current) {
      // console.log(url_);
      // const HTTP = this.$httpUtils.instance;

      return {
        payload,
        deviceData,
        faultsNwarning,
        weatherData: axios.get(url_)
      };
      //   .then(resp => {
      // //   if (resp.data) {
      // //     console.log(resp.data);
      //     return `
      //     <div class="popup-container" href="/device/performance/${InverterId}">
      //      <div class="popup-username">${ownerName}</div>
      //      <div class="popup-body">
      //      <div class="popup-info-section">
      //       <div class="popup-info-section-header">
      //         Inverter
      //       </div>
      //       <div class="popup-info-row">
      //         <strong style="flex: 1">Output:</strong> ${ACOutputApparentPower *
      //           1} kVA
      //       </div>
      //       <div class="popup-info-row">
      //         <strong style="flex: 1">Total Today:</strong> ${
      //           EnergyData
      //             ? Number(EnergyData["ConsumedTodayOffGrid"]) +
      //               Number(EnergyData["ConsumedTodayOnGrid"])
      //             : "-"
      //         } kWh
      //       </div>
      //       <div class="popup-info-row warning-section" style="flex-flow:column">
      //        <h4>Warnings</h4>
      //        <hr>
      //         <strong style="flex: 1; color: #f7cc36;">${
      //           faultsNwarning.inverter.warning &&
      //           faultsNwarning.inverter.warning.length > 0
      //             ? faultsNwarning.inverter.warning.join("<hr>")
      //             : "No warning"
      //         }</strong>
      //       </div>
      //      </div>
      //      <div class="popup-info-section">
      //        <div class="popup-info-section-header">
      //          Battery
      //        </div>
      //         <div class="popup-info-row">
      //            <b style="flex: 1; font-size: 18px;">${BatteryCapacity * 1}%</b>
      //         </div>
      //         <div class="popup-info-row warning-section" style="flex-flow:column">
      //           <h4>Warnings</h4>
      //           <hr>
      //           <strong style="flex: 1; color: #f7cc36;">${
      //             faultsNwarning.battery.warning &&
      //             faultsNwarning.battery.warning.length > 0
      //               ? faultsNwarning.battery.warning.join("<hr>")
      //               : "No warning"
      //           }</strong>
      //         </div>
      //      </div>
      //      <div class="popup-info-section">
      //       <div class="popup-info-section-header">
      //         PV
      //       </div>
      //       <div class="popup-info-row">  <strong style="flex: 1">PV Yield:</strong> ${panelpower} </div>
      //       <div class="popup-info-row">  <strong style="flex: 1">Total Today:</strong> ${
      //         EnergyData ? EnergyData["GeneratedToday"] * 1 : "-"
      //       } kWh </div>
      //       <div class="popup-info-row warning-section" style="flex-flow:column">
      //           <h4>Warnings</h4>
      //           <hr>
      //           <strong style="flex: 1; color: #f7cc36;">${
      //             faultsNwarning.pv.warning &&
      //             faultsNwarning.pv.warning.length > 0
      //               ? faultsNwarning.pv.warning.join("<hr>")
      //               : "No warning"
      //           }</strong>
      //       </div>
      //      </div>
      //     </div>
      //   </div>
      //   `;
      //   });
    },
    getMarker(device) {
      //  console.log(this.errorCalc(this.getDeviceWarning(device)));
      let stat = this.errorCalc(this.getDeviceWarning(device))
        ? this.errorCalc(this.getDeviceWarning(device))
        : "";
      if (stat == "warning") {
        this.devicesWithWarning++;
        // console.log(device)
      } else if (stat == "error") {
        this.devicesWithFault++;
      }
      // return;
      let tmp_ = document.createElement("div");
      tmp_.setAttribute("class", `custom-marker ${stat}`);
      tmp_.innerHTML = `  <div class="map-device-status ${stat}"></div>
        <img src="${icon}" class="marker-pin"/>`;
      // `
      // <div class="custom-marker ${stat}">
      //   <div class="map-device-status ${stat}"></div>
      //   <img src="${icon}" class="marker-pin"/>
      // </div>
      // `;
      return tmp_;
    },
    transformDevice(data) {
      const app = this;

      var image = {
        url: icon,
        // The origin for this image is (0, 0).
        origin: new google.maps.Point(0, 0),
        // The anchor for this image is the base of the flagpole at (0, 32).
        anchor: new google.maps.Point(0, 32)
      };
      // console.log(this.$route.params);
      // payloadDictionary
      // data = [...data, dummyData];

      let type = this.$route.params["live"] == "live" ? true : false;
      return data
        .filter(x => (x.payload ? true : false))
        .map((val, i) => {
          if (val.payload.Version == "v3") {
            let tempData = this.getFetchData(val.DeviceID);
            var resp = "--";
            switch (val.payload.ModeData[0]["Mode"]) {
              case "P":
                resp = "Power On";
                break;
              case "S":
                resp = "On Standby";
                break;
              case "L":
                resp = "On Grid";
                break;
              case "B":
                resp = "On Battery";
                break;
              case "F":
                resp = "Fault";
                break;
              case "H":
                resp = "Power saving mode";
                break;
              case "C":
                resp = "Charging";
                break;
              default:
              // code block
            }
            return {
              version: val.payload.Version,
              InverterId: val.payload.BatteryData.BatteryID,
              TimeStamp: val.payload.TimeStamp,
              OutputLoadPercent: this.roundUp(
                val.payload.InverterData.reduce((acc, obj) => {
                  return (acc += Number(obj["OL%"]));
                }, 0) / val.payload.InverterData.length
              ),
              id: val.payload.DeviceID,
              panelpower: this.panelPower(0),
              BatteryCapacity: val.payload.BatteryData.SOC.replace("%", ""),
              deviceType: tempData.deviceType
                ? tempData.deviceType.name
                : "Arnergy5000",
              ownerName: tempData.name,
              ownerId: tempData.userId,
              address: tempData["locations"],
              batteryMode: resp,
              expiry: val.payload.ExpiryDate,
              lastseen: this.timeAgo(val.payload.TimeStamp)
            };
          } else {
            let tempData = this.getFetchData(val.DeviceID);
            return {
              version: val.payload.version,
              InverterId: val.DeviceID,
              TimeStamp: val.payload.TimeStamp,
              OutputLoadPercent: val.payload.OutputLoadPercent,
              id: tempData.CID,
              panelpower: this.panelPower(val.payload.PVChargingPower),
              BatteryCapacity: val.payload.BatteryCapacity,
              deviceType: tempData.deviceType
                ? tempData.deviceType.name
                : "Arnergy5000",
              ownerName: tempData.name,
              ownerId: tempData.userId,
              address: tempData["locations"],
              batteryMode: this.batteryMode(val.payload.InverterId),
              expiry: this.expiryDate(val.payload.InverterId),
              lastseen: this.timeAgo(val.payload.TimeStamp)
            };
          }
          // }
        })
        .filter(x =>
          x && type ? this.statusCalc(x.TimeStamp) == false : true
        );
    },
    transformDevice(data) {
      // const RichMarker = window.RichMarker;
      const app = this;

      var image = {
        url: icon,
        // The origin for this image is (0, 0).
        origin: new google.maps.Point(0, 0),
        // The anchor for this image is the base of the flagpole at (0, 32).
        anchor: new google.maps.Point(0, 32)
      };
      // this.markerCluster = new MarkerClusterer(this.map);
      // this.markerCluster.setOptions(this.mcOptions);
      return data
        .filter(x => x.payload)
        .filter((val, i) => {
          let tempData = this.getFetchData(val.DeviceID);
          //  console.log("Transform Val", val);
          let deviceAddress;
          let deviceAddress_ = tempData;

          let processedData = {};
          // console.log(i,deviceAddress_['locations']);
          if (deviceAddress_["locations"]) {
            deviceAddress = deviceAddress_["locations"];

            if (val.payload.Version == "v3") {
              let tempData = this.getFetchData(val.DeviceID);
              var resp = "--";
              switch (val.payload.ModeData[0]["Mode"]) {
                case "P":
                  resp = "Power On";
                  break;
                case "S":
                  resp = "On Standby";
                  break;
                case "L":
                  resp = "On Grid";
                  break;
                case "B":
                  resp = "On Battery";
                  break;
                case "F":
                  resp = "Fault";
                  break;
                case "H":
                  resp = "Power saving mode";
                  break;
                case "C":
                  resp = "Charging";
                  break;
                default:
                // code block
              }

              processedData = {
                version: val.payload.Version,
                InverterId: val.payload.BatteryData.BatteryID,
                InverterId: val.payload.InverterId,
                TimeStamp: val.payload.TimeStamp,
                OutputLoadPercent: this.roundUp(
                  val.payload.InverterData.reduce((acc, obj) => {
                    return (acc += Number(obj["OL%"]));
                  }, 0) / val.payload.InverterData.length
                ),
                id: val.payload.DeviceID,
                panelpower: this.panelPower(0),
                BatteryCapacity: val.payload.BatteryData.SOC.replace("%", ""),
                deviceType: tempData.deviceType
                  ? tempData.deviceType.name
                  : "Arnergy5000",
                ownerName: tempData.name,
                ownerId: tempData.userId,
                address: tempData["locations"],
                batteryMode: resp,
                expiry: val.payload.ExpiryDate,
                lastseen: this.timeAgo(val.payload.TimeStamp),
                // batteryMode: this.batteryMode(val.payload.InverterId),
                // expiry: this.expiryDate(val.payload.InverterId),
                // lastseen: this.timeAgo(val.payload.TimeStamp),
                location: deviceAddress,
                // generatedToday:'-',
                // peakToday: '-',
                generatedToday: val.payload["EnergyData"]
                  ? val.payload["EnergyData"]["GeneratedToday"]
                  : "-",
                peakToday: val.payload["EnergyData"]
                  ? val.payload["EnergyData"]["PeakToday"]
                  : "-"
              };
            } else {
              processedData = {
                version: val.payload.version,
                InverterId: val.DeviceID,
                TimeStamp: val.payload.TimeStamp,
                OutputLoadPercent: val.payload.OutputLoadPercent,
                id: tempData.CID,
                panelpower: this.panelPower(val.payload.PVChargingPower),
                BatteryCapacity: val.payload.BatteryCapacity,
                deviceType: tempData.deviceType
                  ? tempData.deviceType.name
                  : "Arnergy5000",
                ownerName: tempData.name,
                ownerId: tempData.userId,
                address: tempData["locations"],
                batteryMode: this.batteryMode(val.payload.InverterId),
                expiry: this.expiryDate(val.payload.InverterId),
                lastseen: this.timeAgo(val.payload.TimeStamp),
                location: deviceAddress,
                generatedToday: val.payload["EnergyData"]
                  ? val.payload["EnergyData"]["GeneratedToday"]
                  : "-",
                peakToday: val.payload["EnergyData"]
                  ? val.payload["EnergyData"]["PeakToday"]
                  : "-"
              };
            }

            let locationKey = `${deviceAddress.position.lat}${deviceAddress.position.lng}`;
            // this.markerFrequency[locationKey] = isNaN(this.markerFrequency[locationKey]) ? [processedData] : [...this.markerFrequency[locationKey],processedData ]
            //  console.log( this.markerFrequency[locationKey]);
            // console.log("+++++++++++++++++++++++++++++=");

            const position = new google.maps.LatLng(
              deviceAddress.position.lat,
              deviceAddress.position.lng
            );

            const marker = new google.maps.Marker({
              position,
              icon: image,
              map: this.map,
              label:""
            });
            // console.log({RichMarker})
            // let marker = new RichMarker({
            //   position,
            //   map: this.map,
            //   content: this.getMarker(processedData.InverterId),
            //   anchor: 5
            // });
            // let Popup =   createPopupClass();
            // let marker = new Popup(
            //   position,
            //   this.getMarker(processedData.InverterId)
            // );
            // marker.setMap(this.map);

            // console.log(app.getPopUp(processedData, val.payload));
            google.maps.event.addListener(marker, "click", function(e) {
              let popUpData = app.getPopUp(processedData, val.payload);

              var { ACOutputApparentPower, EnergyData } = popUpData.payload;

              var {
                InverterId,
                TimeStamp,
                OutputLoadPercent,
                id,
                panelpower,
                BatteryCapacity,
                deviceType,
                ownerName,
                ownerId,
                batteryMode,
                expiry,
                lastseen,
                location,
                generatedToday,
                peakToday
              } = popUpData.deviceData;
              let faultsNwarning = popUpData.faultsNwarning;

              popUpData.weatherData.then(_resp => {
                let weatherPayload = _resp.data;
                let popUp = `
                <div class="popup-container">
                  <div class="popup-username">
                    ${ownerName}
                    <div><a class="btn btn-info" href="/device/performance/${InverterId}/${
                  processedData.version ? processedData.version : "v2"
                }">See Details</a></div>

                  </div>
                  <main>
                    <input id="inverter_section" type="radio" name="tabs" checked>
                    <label for="inverter_section">Inverter</label>

                    <input id="battery_section" type="radio" name="tabs">
                    <label for="battery_section">Battery</label>

                    <input id="pv_section" type="radio" name="tabs">
                    <label for="pv_section">PV</label>

                    <section id="inverter_content">
                      <div class="panel text-center" style: "color: #AEAEAE;">
                        <div class="popup-info-section">

                          <div class="popup-info-row" style="color: #AEAEAE;">
                            <strong style="flex: 1; text-align: left; color: #AEAEAE;">Output:</strong> ${Number(
                              ACOutputApparentPower
                            ) / 1000} kVA
                          </div>
                          <div class="popup-info-row" style="color: #AEAEAE;">
                            <strong style="flex: 1; text-align: left; color: #AEAEAE;">Total Today:</strong> ${
                              EnergyData
                                ? Number(EnergyData["ConsumedTodayOffGrid"]) +
                                  Number(EnergyData["ConsumedTodayOnGrid"])
                                : "-"
                            } kWh
                          </div>
                          <div class="popup-info-row warning-section" style="color: #AEAEAE;">
                            <strong style="flex: 1; text-align: left; color: #AEAEAE;">Warnings:</strong> ${
                              faultsNwarning.inverter.warning &&
                              faultsNwarning.inverter.warning.length > 0
                                ? faultsNwarning.inverter.warning
                                : "No warning"
                            }

                          </div>
                        </div>
                      </div>
                    </section>

                    <section id="battery_content">
                      <div class="panel text-center">
                        <div class="popup-info-section">

                          <div class="popup-info-row" style="color: #AEAEAE;">
                            <strong style="flex: 1; text-align: left; color: #AEAEAE;">Battery percentage:</strong> ${BatteryCapacity *
                              1}%

                          </div>
                          <div class="popup-info-row warning-section" style="color: #AEAEAE;">
                            <strong style="flex: 1; text-align: left; color: #AEAEAE;">Warnings:</strong> ${
                              faultsNwarning.inverter.warning &&
                              faultsNwarning.inverter.warning.length > 0
                                ? faultsNwarning.inverter.warning
                                : "No warning"
                            }

                          </div>
                        </div>
                      </div>

                    </section>

                    <section id="pv_content">
                        <div class="panel text-center">
                          <div class="popup-info-section">

                            <img width='60' src="http://www.weatherunlocked.com/Images/icons/2/${weatherPayload[
                              "wx_icon"
                            ].replace(".gif", ".png")}">
                            <h6>${weatherPayload["wx_desc"]}</h6>
                            <div class="popup-info-row" style="color: #AEAEAE;">  <strong style="flex: 1; text-align: left;">PV Yield:</strong> ${panelpower} </div>
                            <div class="popup-info-row" style="color: #AEAEAE;">  <strong style="flex: 1; text-align: left;">Total Today:</strong> ${
                              EnergyData
                                ? EnergyData["GeneratedToday"] * 1
                                : "-"
                            } kWh
                            </div>
                            <div class="popup-info-row warning-section" style="color: #AEAEAE;">
                              <strong style="flex: 1; text-align: left; color: #AEAEAE;">Warnings:</strong> ${
                                faultsNwarning.inverter.warning &&
                                faultsNwarning.inverter.warning.length > 0
                                  ? faultsNwarning.inverter.warning
                                  : "No warning"
                              }

                            </div>
                          </div>
                        </div>
                    </section>

                  </main>
                </div>
              `;
                // console.log(_resp.data);
                var myOptions = {
                  content: popUp,
                  maxWidth: 600
                };
                if (ib) {
                  ib.close();
                }
                ib = new google.maps.InfoWindow(myOptions);
                ib.open(this.map, marker);
              });
              // console.log(popUp);
            });
            this.markers.push(marker);
            // this.markerCluster.addMarker(marker);
            this.map.fitBounds(this.bounds.extend(position));

            return processedData;
          }
        });
    },
    getDevice() {
      const context = this;
      const HTTP = this.$httpUtils.instance;
      // &filter[include]=deviceRequest
      //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
      const url = `/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations`;
      HTTP.get(url)
        .then(response => {
          // console.log(response);
          context.fetchData = response.data;
          context.myDevices = this.transformDevice(context.DeviceList.devices);
          console.log(context.myDevices);
        })
        .catch(error => {
          // return "not assign";
          console.log("error", error);
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    submitAddForm() {
      // console.log(JSON.stringify(this.formDevice));
      var dataParam = this.formDevice;
      if (
        dataParam.DeviceID === null ||
        dataParam.device_type.name === null ||
        dataParam.location.address === null ||
        dataParam.customer.name === null ||
        dataParam.customer.phone === null ||
        dataParam.DeviceID === "" ||
        dataParam.device_type.name === "" ||
        dataParam.location.address === "" ||
        dataParam.customer.name === "" ||
        dataParam.customer.phone === ""
      ) {
        let obj = {
          title: "Please fill all fields!!!",
          message: "",
          type: "error",
          onClose: this.onClose
        };
        this.$refs.simplert.openSimplert(obj);
        // alert('Please fill all fields!!!')
      } else {
        const me = this;
        const HTTP = this.$httpUtils.instance;
        HTTP.post("/devices", me.formDevice)
          .then(function(response) {
            me.fetchDevices();
            let obj = {
              title: "Device Created!!!",
              message: "",
              type: "info",
              onClose: me.onClose
            };
            me.$refs.simplert.openSimplert(obj);
          })
          .catch(function(error) {
            // console.log(error);
            let obj = {
              title: "Error, Try again!!!",
              message: "",
              type: "error",
              onClose: me.onClose
            };
            me.$refs.simplert.openSimplert(obj);
          });
        me.hideControl();
      }
    },
    showFormPop() {
      this.$refs.formModal.open();
    },
    hideControl() {
      this.$refs.formModal.cancel();
    },
    formatDate(_date) {
      return moment(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    navTo(device) {
      this.$router.push({
        name: "devicePerformance",
        params: {
          deviceId: device
        }
      });
      // console.log(this.details,device)
    },
    roundUp(num) {
      return Math.round(num * 100) / 100;
    },
    Parse_Json(data) {
      return JSON.parse(data);
    },
    countErrors(Warning) {
      var excluded = [
        "id",
        "deviceID",
        "TimeStamp",
        "TimeStamp",
        "updatedAt",
        "lineFail"
      ];
      var totalErr = 0;
      for (var property in Warning) {
        if (
          Warning.hasOwnProperty(property) &&
          excluded.indexOf(property) < 0
        ) {
          // do stuff
          if (Warning[property] > 0) {
            totalErr++;
            // console.log(property);
          }
        }
      }
      return totalErr;
    },
    findDeviceData(dataset, key, value) {
      const res = dataset.filter(x => x[key] == value);
      return res.length > 0 ? res : undefined;
    },
    batteryMode(deviceID) {
      // console.log(this.DeviceList.modes);
      // this.DeviceList.modes
      const deviceMode = this.findDeviceData(
        this.DeviceList.modes,
        "DeviceID",
        deviceID
      );
      // console.log(deviceID);
      // console.log(deviceMode);
      var mode =
        deviceMode !== undefined ? deviceMode[0]["payload"]["Mode"] : "";
      var resp = "--";
      switch (mode) {
        case "P":
          resp = "Power On";
          break;
        case "S":
          resp = "On Standby";
          break;
        case "L":
          resp = "On Grid";
          break;
        case "B":
          resp = "On Battery";
          break;
        case "F":
          resp = "Fault";
          break;
        case "H":
          resp = "Power saving mode";
          break;
        case "C":
          resp = "Charging";
          break;
        default:
        // code block
      }
      return resp;
    },
    expiryDate(deviceID) {
      const deviceExpiry = this.findDeviceData(
        this.DeviceList.expiries,
        "DeviceID",
        deviceID
      );
      return deviceExpiry !== undefined
        ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"])
        : "--";
    },
    timeAgo(date) {
      // var difference = date.add(1, "hours").fromNow();
      var difference = Math.abs(this.timeRightNow.diff(date));
      return timeAgoUtil(difference);
      // console.log(moment(date, "Africa/Lagos").fromNow());
      // if (difference / 60000 > 90) {
      //   return true;
      // } else {
      //   return false;
      // }
      // console.log(difference);
      // return moment(date)
      //   .add(1, "hours")
      //   .format()
      //   .toString();
    },
    statusCalc(date) {
      var difference = Math.abs(this.timeRightNow.diff(date));
      if (difference / 60000 > 90) {
        return true;
      } else {
        return false;
      }
    },
    statusLabel(date) {
      var difference = Math.abs(moment().diff(date));
      if (difference / 60000 > 90) {
        return "Offline";
      } else {
        return "Online";
      }
    },
    panelPower(PVChargingPower) {
      // console.log(parameters);
      var power = this.roundUp((PVChargingPower * 1) / 1000);
      return power + " kW";
    },
    powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    async fetchDevices() {
      const me = this;
      me.currentTime();
      await this.refreshList();
      this.initGeoMap();
      this.getDevice();
      // console.log("done");
    },
    currentTime() {
      // const me = this;
      // const HTTP = this.$httpUtils.instance;
      // HTTP.get(
      //   "https://script.googleusercontent.com/macros/echo?user_content_key=jiQkpjCE87w3Xo4LsqBwRfiPEaPSIXE_pXTgHsLnv1pKswXN8vzhjCDJEuvAakW_3vjYv917_238sPUo9O_CChOMOPPv7GRMm5_BxDlH2jW0nuo2oDemN9CCS2h10ox_1xSncGQajx_ryfhECjZEnJ9GRkcRevgjTvo8Dc32iw_BLJPcPfRdVKhJT5HNzQuXEeN3QFwl2n0M6ZmO-h7C6bwVq0tbM60-xIkq8d3Ts1nwr1bpxPH2HA&lib=MwxUjRcLr2qLlnVOLh12wSNkqcO1Ikdrk",
      //   {
      //     headers: {
      //       crossdomain: true
      //     },
      //     params: {
      //     }
      //   }
      // )
      //   .then(function(response) {
      //     console.log(JSON.stringify(response.data.fulldate));
      //     me.timeRightNow = moment(response.data.fulldate);
      //   })
      //   .catch(function(error) {
      //     console.log(error);
      //   });
      this.timeRightNow = moment();
    },
    initGeoMap() {
      this.bounds = new google.maps.LatLngBounds();
      const element = document.getElementById("geoDistroMap");
      const mapCentre = {
        latitude: 9.0064697,
        longitude: 4.1765048
      };
      const options = {
        center: new google.maps.LatLng(mapCentre.latitude, mapCentre.longitude),
        zoom: 8,
        scrollwheel: false,
        styles: this.getTheme["theme-name"] == "dark-solarbase" ? darkStyle : {}
      };
      this.map = new google.maps.Map(element, options);
      // this.markerCoordinates.forEach(coord => {
      //   const position = new google.maps.LatLng(coord.latitude, coord.longitude);
      //   const marker = new google.maps.Marker({
      //     position,
      //     map: this.map
      //   });
      //   this.markers.push(marker);
      //   this.map.fitBounds(this.bounds.extend(position));
      // });
    },
    fetchWeather(address) {
      // const HTTP = this.$httpUtils.instance;
      // // lat={lat}&lon={lon}
      // HTTP.get('https://api.openweathermap.org/data/2.5/weather?q=Lagos').then(resp=>{
      //   console.log(resp)
      // });
    }
  },
  created() {},
  mounted() {
    // console.log("Geo Here");
    this.timeRightNow = moment();
    // this.fetchWeather();
    this.fetchDevices();
    // setInterval(this.fetchDevices, 60000);
    // google.maps.event.addDomListener(window, 'load', this.initGeoMap);
    // setTimeout(() => {
    //   this.initGeoMap();
    // }, 500);
  }
};
</script>

<style lang="scss">
.hide_row {
  display: hidden !important;
}
</style>

<style>
.google-map {
  width: 100%;
  min-height: calc(100vh - 60px);
  margin: 0 auto;
  /* background: gray; */
}

.gm-style .gm-style-iw-c {
  padding: 0px !important;
  border-radius: 0% !important;
  /* max-height: 300px !important; */
}
.gm-style .gmnoprint {
  display: none !important;
}
</style>

<style lang="scss" scoped>
// @import "@/assets/scss/_variables";

.popup-container {
  //background: red;
  border: none;
  padding: 0px;
}
section {
  display: none;
  padding: 20px 0 0;
  // border-top: 1px solid #abc;
}

input {
  display: none;
  background-color: rgb(161, 158, 158);
}

label {
  display: inline-block;
  margin: 0 0 -1px;
  padding: 15px 25px;
  font-weight: 600;
  text-align: center;
  color: rgb(161, 158, 158);
  background-color: #ebeff2;
  // border: 1px solid transparent;
}

label:before {
  // font-family: fontawesome;
  font-weight: normal;
  margin-right: 10px;
}

label[for*="1"]:before {
  content: "\f1cb";
}

label[for*="2"]:before {
  content: "\f17d";
}

label[for*="3"]:before {
  content: "\f16c";
}

label[for*="4"]:before {
  content: "\f171";
}

label:hover {
  color: #789;
  background-color: #fff;
  cursor: pointer;
}

input:checked + label {
  color: #6a707e;
  background-color: #fff;
  // border: 1px solid #abc;
  // border-top: 1px solid #fff;
  // border-bottom: 1px solid #fff;
}

#inverter_section:checked ~ #inverter_content,
#battery_section:checked ~ #battery_content,
#pv_section:checked ~ #pv_content,
#tab4:checked ~ #content4 {
  display: block;
}

@media screen and (max-width: 800px) {
  label {
    font-size: 0;
  }

  label:before {
    margin: 0;
    font-size: 18px;
  }
}
@media screen and (max-width: 500px) {
  label {
    padding: 15px;
  }
}
// .popup-container .tab-groups {
//   display: flex;
// }
// .popup-container .tabs {
//   display: flex;
//   flex: 1;
//   justify-content: center;
//   background: #e5e5e5;
//   flex-flow: row wrap;
//   // background: #fff;
// }
// .popup-container .tabs input {
//   position: absolute;
//   opacity: 0;
// }
// .popup-container .tabs label {
//   // width: 100%;
//   padding: 20px 30px;
//   // text-align: center;
//   cursor: pointer;
//   font-weight: bold;
//   font-size: 12px;
//   color: #7f7f7f;
//   transition: background 0.1s, color 0.1s;
// }

// .popup-container .tabs:hover {
//   background: #fff;
// }

// .popup-container .tabs:active {
//   background: #ccc;
// }

// .popup-container .tabs .input:focus + .label {
//   z-index: 1;
// }
// .popup-container .tabs .input:checked
// {
//   background: #fff;
//   color: #000;
// }
// .popup-container .tabs .input:checked + .label {
//   background: #fff;
//   color: #000;
// }

// .popup-container .tabs .panel {
//   display: none;
//   width: 100%;
//   background: #fff;
//   margin-bottom: 0px !important;
// }

// .popup-container .tabs .input:checked + .label + .panel {
//   display: block !important;
// }

.popup-container.error {
  border-top: 5px solid rgba(252, 0, 0, 1);
}

// .popup-body {
//   display: flex;
//   // flex-flow: row;
// }

.popup-username {
  color: #ffffff;
  background: #1a93ca;
  padding: 10px;
  text-transform: uppercase;
  font-weight: 600;
  width: auto;
  text-align: left;
  display: flex;
}
.popup-username div .btn-info {
  background: #ffb946 !important;
  border-color: #ffb946 !important;
  position: absolute !important;
  right: 20px !important;
  padding: 0.04px 20px !important;
  font-size: 12px !important;
}

// .popup-header {
//   display: flex;
//   border-bottom: 1px solid #ddd;
//   padding: 10px;
// }

// .popup-info-section-header {
//   font-weight: 600;
//   font-size: 15px;
// }

// .popup-info-section {
//   margin-top: 15px;
//   text-align: center;
//   width: 100%;
// }

// .popup-info-section:last-child {
//   border: none;
// }

.popup-info-row {
  display: flex;
  padding: 10px;
  background: #fefefe;
}

// .popup-info-row strong {
//   float: left;
//   text-align: left;
//   // font-weight: 200;
// }

// // .popup-info-row:nth-child(odd) {
// //   // background: #eeee
// // }

.legend_accordion {
  position: absolute;
  top: 150px;
  left: 5%;
  width: 320px;
  padding: 10px;
  background: white !important;
  // padding: 10px 10px;
}
.card-header {
  background: #fff !important;
}
.card-header.p-1 a {
  background: #fff !important;
  border: none !important;
}
.card-header a {
  color: #6a707e !important;
  font-weight: 600;
}
// .box-card .box-card_divider {
//   padding: 5px 0px !important;
//   width: 100%;
// }
.card-body .legend-keys {
  display: flex;
  // flex-flow: row;
  text-align: center;
}
.card-body .legend-keys .keys {
  margin-right: 15px;
  margin-bottom: 5px;
}
.card-body .legend-keys .keys span {
  display: flex;
  flex-flow: column;
}
.card-body .legend-keys .keys span img {
  width: 24px;
  height: 24px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/performance/geoDistro.vue